"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTrash03 = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M8 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1.064l-.642 9.625c-.05.756-.092 1.381-.167 1.89-.078.53-.201 1.014-.458 1.465a4 4 0 0 1-1.731 1.62c-.467.226-.959.317-1.493.36-.512.04-1.139.04-1.896.04h-3.098c-.757 0-1.384 0-1.896-.04-.534-.043-1.025-.134-1.493-.36a4 4 0 0 1-1.73-1.62c-.258-.451-.381-.935-.46-1.465-.074-.509-.115-1.134-.166-1.89L4.064 7H3a1 1 0 0 1-1-1Zm8 3.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z", fill: "currentColor" })] }))); };
exports.default = SvgTrash03;
